module.exports = __webpack_public_path__ + "static/media/giphy.e72b5880.gif";